'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _containers = require('containers');

var _components = require('components');

var _lib = require('helpers/lib');

var _support = require('helpers/support');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  var requireLogin = function requireLogin(nextState, replace, cb) {
    function checkAuth() {
      var _store$getState = store.getState(),
          user = _store$getState.auth.user;

      if (!user) {
        // oops, not logged in, so can't be here!
        replace({ nextPathname: nextState.location.pathname }, '/dang-nhap');
      }
      cb();
    }
    checkAuth();
  };
  var requireNotLogin = function requireNotLogin(nextState, replace, cb) {
    function checkAuth() {
      var _store$getState2 = store.getState(),
          user = _store$getState2.auth.user;

      if (user) {
        // oops, not logged in, so can't be here!
        replace('/tai-khoan');
      }
      cb();
    }
    checkAuth();
  };
  var requireBooking = function requireBooking(nextState, replace, cb) {
    function checkBooking() {
      var _store$getState3 = store.getState(),
          shop = _store$getState3.booking.submit.shop;

      if (!shop) {
        replace('/');
      }
      cb();
    }
    checkBooking();
  };
  var getDesktopRoutes = function getDesktopRoutes() {
    return _react2.default.createElement(
      _reactRouter.Route,
      { path: '/', component: _containers.AppDesktop },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Home }),
      _react2.default.createElement(
        _reactRouter.Route,
        { onEnter: requireLogin },
        _react2.default.createElement(_reactRouter.Route, { path: 'tai-khoan', component: _containers.Account })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { onEnter: requireNotLogin },
        _react2.default.createElement(_reactRouter.Route, { path: 'dang-nhap', component: _containers.Login })
      ),
      _react2.default.createElement(_reactRouter.Route, { path: 'kham-pha', component: _containers.Category }),
      _react2.default.createElement(_reactRouter.Route, { path: 'dang-ki-doi-tac', component: _containers.PartnerRegistration }),
      _react2.default.createElement(_reactRouter.Route, { path: 'cam-on', component: _containers.Thanks }),
      _react2.default.createElement(_reactRouter.Route, { path: 'cham-soc-da-massage', component: _containers.Category }),
      _react2.default.createElement(_reactRouter.Route, { path: 'lam-toc-mong', component: _containers.Category }),
      _react2.default.createElement(_reactRouter.Route, { path: 'tham-my-vien', component: _containers.Category }),
      _react2.default.createElement(_reactRouter.Route, { path: 'phong-kham', component: _containers.Category }),
      _react2.default.createElement(_reactRouter.Route, { path: 'the-duc-the-thao', component: _containers.Category }),
      _react2.default.createElement(_reactRouter.Route, { path: 'xam-hinh', component: _containers.Category }),
      _react2.default.createElement(_reactRouter.Route, { path: 'salon-mi-va-mong', component: _containers.Category }),
      _react2.default.createElement(_reactRouter.Route, { path: 'spa-cham-da', component: _containers.Category }),
      _react2.default.createElement(_reactRouter.Route, { path: 'massage-va-goi-dau', component: _containers.Category }),
      _react2.default.createElement(_reactRouter.Route, { path: 'tham-my-va-nha-khoa', component: _containers.Category }),
      _react2.default.createElement(_reactRouter.Route, { path: 'salon-toc-va-make-up', component: _containers.Category }),
      _react2.default.createElement(_reactRouter.Route, { path: 'chinh-sach/:query', component: _containers.Policy }),
      _react2.default.createElement(_reactRouter.Route, { path: 'bo-suu-tap', component: _containers.CollectionList }),
      _react2.default.createElement(_reactRouter.Route, { path: 'bo-suu-tap/:handle', component: _containers.CollectionDetail }),
      _react2.default.createElement(_reactRouter.Route, { path: 'uu-dai', component: _containers.Promotion }),
      _react2.default.createElement(_reactRouter.Route, {
        path: 'uu-dai-goi/:campaignHandle',
        component: _containers.GeneralCampaignListPromotion
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: 'uu-dai-doi-tac/:campaignHandle',
        component: _containers.ServiceDetailDesktop,
        availableOnMobile: !false
      }),
      _react2.default.createElement(_reactRouter.Route, { path: 'bang-gia', component: _containers.PricingPlans, page: 'PricingPlans' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'uu-dai/:handle', component: _containers.PromotionDetail }),
      _react2.default.createElement(_reactRouter.Redirect, { path: 'shop/:id', to: ':id' }),
      _react2.default.createElement(_reactRouter.Route, { path: ':id', component: _containers.Detail }),
      _react2.default.createElement(_reactRouter.Route, {
        path: 'dich-vu/:handle',
        component: _containers.ServiceDetailDesktop,
        availableOnMobile: !false
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: 'kol/:code',
        component: _components.LinkPartnerMobile,
        page: 'LinkPartnerMobile'
      }),
      _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
    );
  };
  var getMobileRoutes = function getMobileRoutes() {
    return _react2.default.createElement(
      _reactRouter.Route,
      { path: '/', component: _containers.AppMobile },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _components.HomeMobile, page: 'Home' }),
      _react2.default.createElement(_reactRouter.Route, {
        path: 'dang-ki-doi-tac',
        component: _containers.PartnerRegistration,
        page: 'PartnerRegistration'
      }),
      _react2.default.createElement(_reactRouter.Route, { path: 'cam-on', component: _containers.Thanks, page: 'thanks' }),
      _react2.default.createElement(
        _reactRouter.Route,
        { onEnter: requireNotLogin },
        _react2.default.createElement(_reactRouter.Route, { path: 'dang-nhap', component: _components.LoginMobile, page: 'Login' })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        null,
        _react2.default.createElement(_reactRouter.Route, { path: 'kham-pha', component: _components.NewCategoryMobile, page: 'Category' }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'cham-soc-da-massage',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: '01'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'lam-toc-mong',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: '02'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'tham-my-vien',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: '03'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'phong-kham',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: '04'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'the-duc-the-thao',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: '05'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'xam-hinh',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: '06'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'salon-mi-va-mong',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: 'M1'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'spa-cham-da',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: 'M2'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'massage-va-goi-dau',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: 'M3'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'tham-my-va-nha-khoa',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: 'M4'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'salon-toc-va-make-up',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: 'M5'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'workshop',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: 'M6'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'life-coach',
          component: _components.NewCategoryMobile,
          page: 'Category',
          cat: 'M7'
        })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        null,
        _react2.default.createElement(_reactRouter.Redirect, { path: 'uudai', to: 'uu-dai' }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai',
          component: _components.LookmeReward,
          text: 'Ưu Đãi',
          page: 'Promotion'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-tai-nha',
          component: _components.LookmeReward,
          text: 'Ưu Đãi Tại Nhà',
          page: 'PromotionAtHome'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-tai-spa',
          component: _components.LookmeReward,
          text: 'Ưu Đãi Tại Spa',
          page: 'PromotionAtSpa'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-trai-nghiem',
          component: _components.ExchangePromotionScreen,
          text: 'Ưu Đãi Trải Nghiệm',
          page: 'PromotionNoStar'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-5-sao',
          component: _components.ExchangePromotionScreen,
          text: 'Ưu Đãi 5 Sao',
          page: 'PromotionFiveStar'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-toi',
          component: _components.BookingPromotionScreen,
          text: 'Ưu Đãi Của Tôi',
          page: 'MyPromotion'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-goi/:campaignHandle',
          component: _components.GeneralCampaignList,
          text: 'Ưu Đãi Bạn Bè',
          page: 'GeneralCampaignList'
        }),
        _react2.default.createElement(_reactRouter.Route, { path: 'voucher-detail/:voucherId', component: _components.VoucherDetailById }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-cham-soc-da-massage',
          component: _components.VoucherFilter,
          page: 'VoucherFilter01',
          cat: '01'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-lam-toc-mong',
          component: _components.VoucherFilter,
          page: 'VoucherFilter02',
          cat: '02'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-tham-my-vien',
          component: _components.VoucherFilter,
          page: 'VoucherFilter03',
          cat: '03'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-phong-kham',
          component: _components.VoucherFilter,
          page: 'VoucherFilter04',
          cat: '04'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-the-duc-the-thao',
          component: _components.VoucherFilter,
          page: 'VoucherFilter05',
          cat: '05'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-xam-hinh',
          component: _components.VoucherFilter,
          page: 'VoucherFilter06',
          cat: '06'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-dich-vu-tai-nha',
          component: _components.VoucherFilter,
          page: 'VoucherFilter07',
          cat: '07'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai/:handle',
          component: _components.ExchangeReward,
          page: 'ExchangeReward'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-doi-tac',
          component: _components.CampaignPartnerDetail,
          page: 'CampaignPartner'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'uu-dai-doi-tac/:campaignHandle',
          component: _components.ServiceByCampaignDetail,
          page: 'ServiceByCampaignDetail'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'huong-dan-doi-tac',
          component: _components.GuideEnterprise,
          page: 'GuideEnterprise'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'kol/:code',
          component: _components.LinkPartnerMobile,
          page: 'LinkPartnerMobile'
        }),
        _react2.default.createElement(
          _reactRouter.Route,
          { onEnter: requireLogin },
          _react2.default.createElement(_reactRouter.Route, {
            path: 'uu-dai-cua-toi/:code',
            component: _components.BookingReward,
            page: 'BookingReward'
          })
        )
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'chinh-sach' },
        _react2.default.createElement(_reactRouter.Route, {
          path: 'thong-tin-lien-he',
          component: _components.PolicyMobile,
          page: 'PolicyMobile1'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'quy-che-hoat-dong',
          component: _components.PolicyMobile,
          page: 'PolicyMobile2'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'giai-quyet-tranh-chap',
          component: _components.PolicyMobile,
          page: 'PolicyMobile3'
        }),
        _react2.default.createElement(_reactRouter.Route, { path: 'bao-mat', component: _components.PolicyMobile, page: 'PolicyMobile4' }),
        _react2.default.createElement(_reactRouter.Route, { path: ':query', component: _components.PolicyMobile, page: 'PolicyMobile' })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        null,
        _react2.default.createElement(
          _reactRouter.Route,
          { onEnter: requireBooking },
          _react2.default.createElement(_reactRouter.Route, { path: 'dat-lich', component: _components.StepOne, page: 'BookingOne' }),
          _react2.default.createElement(_reactRouter.Route, { path: 'dat-lich-2', component: _components.StepTwo, page: 'BookingTwo' }),
          _react2.default.createElement(_reactRouter.Route, { path: 'dat-lich-3', component: _components.StepThree, page: 'BookingThree' })
        ),
        _react2.default.createElement(
          _reactRouter.Route,
          { onEnter: requireLogin },
          _react2.default.createElement(_reactRouter.Route, {
            path: 'lich-hen',
            component: _components.ManageBookingRequest,
            page: 'ManageBookingTab'
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'quan-ly-dat-cho',
            component: _components.ManageBookingRequest,
            page: 'ManageBooking'
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'lich-hen/:bookingRequestId',
            component: _components.BookingRequestDetail,
            page: 'BookingRequestDetail'
          })
        )
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        null,
        _react2.default.createElement(_reactRouter.Route, { path: 'tai-khoan', component: _components.AccountMobile, page: 'Account' }),
        _react2.default.createElement(
          _reactRouter.Route,
          { onEnter: requireLogin },
          _react2.default.createElement(_reactRouter.Route, {
            path: 'lich-su-hoat-dong',
            component: _components.ActivityMobile,
            page: 'Activity',
            name: 'activity'
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'history',
            component: _components.HistoryMobile,
            page: 'History',
            name: 'history'
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'chinh-sua-tai-khoan',
            component: _components.ProfileMobile,
            page: 'Profile'
          }),
          _react2.default.createElement(_reactRouter.Route, {
            path: 'quan-ly-uu-dai',
            component: _components.ManagePromotion,
            text: 'Quản lý ưu đãi',
            page: 'ManagePromotion'
          })
        ),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'thong-bao',
          component: _components.NotificationMobile,
          page: 'Notification'
        }),
        _react2.default.createElement(_reactRouter.Route, { path: 'gop-y', component: _components.FeedbackMobile, page: 'Feedback' }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'quyen-loi-thanh-vien',
          component: _components.MembershipBenefit,
          page: 'MembershipBenefit'
        })
      ),
      _support.Helper.isDev() && _react2.default.createElement(
        _reactRouter.Route,
        null,
        _react2.default.createElement(_reactRouter.Route, {
          path: 'lich-su-nap-tien',
          component: _components.PaymentHistory,
          page: 'PaymentHistory'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'phuong-thuc-thanh-toan',
          component: _components.PaymentList,
          page: 'PaymentList'
        })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        null,
        _react2.default.createElement(_reactRouter.Route, {
          path: '/bo-suu-tap',
          component: _components.CollectionListMobile,
          page: 'CollectionList'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: '/bo-suu-tap/:handle',
          component: _components.CollectionDetailMobile,
          page: 'CollectionDetail'
        })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        null,
        _react2.default.createElement(_reactRouter.Route, {
          path: 'khuyen-mai/:id',
          component: _components.DetailBannerInfo,
          page: 'DetailBannerInfo'
        })
      ),
      _react2.default.createElement(_reactRouter.Route, {
        path: 'bang-gia',
        component: _components.PricingPlansMobile,
        page: 'PricingPlans'
      }),
      _react2.default.createElement(
        _reactRouter.Route,
        null,
        _react2.default.createElement(
          _reactRouter.Route,
          { onEnter: requireLogin },
          _react2.default.createElement(_reactRouter.Route, {
            path: ':shopHandle/viet-danh-gia',
            component: _components.NewReviewMobile,
            page: 'NewReview'
          }),
          _react2.default.createElement(_reactRouter.Route, { path: 'tao-cua-hang', component: _components.NewShopMobile, page: 'NewShop' }),
          _react2.default.createElement(_reactRouter.Route, { path: 'chat/:shopHandle', component: _components.Chat, page: 'Chat' })
        ),
        _react2.default.createElement(_reactRouter.Route, {
          path: ':shopHandle/danh-gia',
          component: _components.ShopReviewPage,
          page: 'ShopReview'
        }),
        _react2.default.createElement(_reactRouter.Redirect, { path: 'shop/:id', to: ':id' }),
        _react2.default.createElement(_reactRouter.Route, { path: ':id', component: _components.DetailMobile, page: 'ShopDetail' }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'dich-vu/:handle',
          component: _components.ServiceDetailMobile,
          page: 'ServiceDetailMobile'
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'thong-tin-shop/:id',
          component: _components.MoreInfoDetailMobile,
          page: 'MoreInfoShopDetail'
        })
      ),
      _react2.default.createElement(_reactRouter.Route, { path: '*', component: _components.NotFoundMobile, status: 404, page: 'NotFound' })
    );
  };
  /**
   * Please keep routes in alphabetical order
   */
  // const height = (global && global.screen && global.screen.height) || 800;
  // const width = (global && global.screen && global.screen.width) || 800;
  // const isDesktop = width > 768 && height >= 700;
  return (0, _lib.isMobile)() ? getMobileRoutes() : getDesktopRoutes();
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 1706
// module chunks = 0